import { useAuthState } from "@/hooks/useAuthState";

export const useIsSignedInStable = () => {
  // abstraction around auth state to be used to gate presentational components
  // that should only be visible when authenticated
  const { isSignedIn, isLoading, isInitializing } = useAuthState();
  return isSignedIn && !isLoading && !isInitializing;
};
